var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"activitySetup"},[_c('v-app',[_c('v-container',[_c('v-layout',{staticStyle:{"padding-top":"20vh"},attrs:{"row":"","wrap":"","justify-center":""}},[_c('center',[_c('div',{staticClass:"double-spinner",staticStyle:{"margin-right":"10px"}})])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }